/**
 * The derived stock quantities the inventory UI speaks, defined once.
 * Available can be null (no inventory row yet) and even negative (oversold),
 * so every input is normalized here.
 *
 * The sellable figure is deliberately NOT derived here: the server computes it in the
 * inventory_sellable view (V140) and every payload carries `sellableQty` — a local formula
 * would get the no-inventory-row case wrong, which is exactly the bug the view fixed.
 *
 * Quantities may carry up to 3 decimals (CHG-2026-09-stock-usage-and-price-twins, D1), so the
 * arithmetic runs in integer thousandths: whole numbers come out exactly as before, and 1.3 + 0.2
 * is 1.5, not 1.5000000000000002.
 */
import {
  addStockQuantities,
  subtractStockQuantities,
} from '@/shared/lib/stock-quantity'

/** What is physically on the shelf: available plus what open orders reserve. */
export function onHandQty(
  availableQty: number | null | undefined,
  reservedQty: number | null | undefined,
): number {
  return addStockQuantities(availableQty, reservedQty)
}

/**
 * The available quantity a physical count establishes: the operator counts
 * on-hand, the server stores available. A count below the reserved quantity
 * clamps to 0 — the server rejects negative writes (RULE-CLOUD-INV-008).
 */
export function availableFromCount(
  countedOnHand: number,
  reservedQty: number,
): number {
  return Math.max(0, subtractStockQuantities(countedOnHand, reservedQty))
}
